import { render, staticRenderFns } from "./connect_box.vue?vue&type=template&id=7c2ca94d&scoped=true"
import script from "./connect_box.vue?vue&type=script&lang=js"
export * from "./connect_box.vue?vue&type=script&lang=js"
import style0 from "./connect_box.vue?vue&type=style&index=0&id=7c2ca94d&prod&scoped=true&lang=css"
import style1 from "./connect_box.vue?vue&type=style&index=1&id=7c2ca94d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2ca94d",
  null
  
)

export default component.exports